import type { Ref } from 'vue'

const appVersion = process.env.VUE_APP_VERSION || '0.0.1'

export type ContextUserType = {
  id: number
  auth: string
  code: string
  flower_type_id: number | null
  role: string
  role_id?: number
  role_code?: string | null
  user_type: string | null
  enabled_jobs: string[]
  readonly_jobs: string[]
  member: Record<string, any> | null
  buyer: Record<string, any> | null
}

export type LoginType = {
  code: string | null
  pass: string | null
}

export const loginInit = (): LoginType => ({
  code: null,
  pass: null
})

export type SelfType = {
  version: string
  login: Record<string, any>
  member: ContextUserType | null
  buyer: ContextUserType | null
}

export type AuthType = {
  localVersion: string
  serverVersion: string
  user: ContextUserType
  isLoaded: boolean
}

export type AuthResponseType = {
  status: boolean
  messages: string[]
}

export interface IAuth {
  me: Ref<AuthType>
  reload(force?: boolean): Promise<boolean>
  login(value?: number | ContextUserType | LoginType): Promise<AuthResponseType>
  getTokenSilently(): Promise<string>
  isAuthenticated(): Promise<boolean>
  logout(): Promise<void>
}

export const initAuth = (): AuthType => {
  return {
    localVersion: appVersion,
    serverVersion: '0',
    user: {
      id: 0,
      auth: '',
      code: '',
      flower_type_id: null,
      role: 'user',
      user_type: 'member',
      enabled_jobs: [],
      readonly_jobs: [],
      member: null,
      buyer: null
    },
    isLoaded: false
  }
}

export const buildAuth = (self: SelfType): AuthType => {
  const baseUser = (self.member || self.buyer) as ContextUserType
  return {
    localVersion: appVersion,
    serverVersion: self.version,
    user: {
      ...baseUser,
      role_id: self.login?.role_id,
      role_code: self.login?.role_code
    } as ContextUserType,
    isLoaded: true
  }
}
